// @flow

import classNames from 'classnames';
import React, { Fragment } from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReviewsIcon, StarIcon } from '@riseart/icons';
import { Link, Paragraph } from '@riseart/common';
import { LocalizedConfig } from 'shared_services/riseart/utils/LocalizedConfig';

import {
  cmsModuleTestimonialCls,
  cmsModuleTestimonialTypeLargeCls,
  cmsModuleTestimonialTextCls,
  cmsModuleTestimonialFooterCls,
  cmsModuleTestimonialDetailsCls,
  cmsModuleTestimonialStarsCls,
  cmsModuleTestimonialAuthorCls,
  cmsModuleTestimonialLinkCls,
} from 'shared_components/cms/modules/testimonial/Testimonial.less';

type Props = {
  type: 'small' | 'large',
  author: string,
  country: string,
  text: Node,
  score?: number,
};
/**
 * CmsModuleTestimonial
 *
 * @param {Props} props
 */
export const CmsModuleTestimonial = ({
  type,
  text,
  author,
  country,
  score = 5,
}: Props = {}): Node => {
  if (!text) {
    return null;
  }

  const isLargeType = type === 'large';

  return (
    <div
      className={classNames(cmsModuleTestimonialCls, {
        [cmsModuleTestimonialTypeLargeCls]: isLargeType,
      })}
    >
      <Paragraph className={cmsModuleTestimonialTextCls}>{text}</Paragraph>
      <div className={cmsModuleTestimonialFooterCls}>
        <span className={cmsModuleTestimonialDetailsCls}>
          {!isLargeType ? (
            <span className={cmsModuleTestimonialStarsCls}>
              {Array.apply(0, Array(score)).map((item, starIconIndex) => (
                <StarIcon key={starIconIndex} />
              ))}
            </span>
          ) : null}
          <span className={cmsModuleTestimonialAuthorCls}>
            {author}
            {country ? <Fragment>, {country}</Fragment> : null}
          </span>
        </span>
        <span className={cmsModuleTestimonialLinkCls}>
          <FormattedMessage id="common.reviews">
            {(title: string) => (
              <Link
                external
                href={LocalizedConfig.get('externalUrls.companyReviews')}
                title={title}
                target="_blank"
              >
                {isLargeType ? (
                  <span className={cmsModuleTestimonialStarsCls}>
                    {Array.apply(0, Array(score)).map((item, starIconIndex) => (
                      <StarIcon key={starIconIndex} />
                    ))}
                  </span>
                ) : null}
                <ReviewsIcon />
              </Link>
            )}
          </FormattedMessage>
        </span>
      </div>
    </div>
  );
};
